import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'fr8bot-ui-checkmark-icon',
  imports: [],
  templateUrl: './checkmark-icon.component.html',
  styleUrl: './checkmark-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckmarkIconUIComponent {}
